<template>
  <v-card flat class="auth-clients--header" color="transparent">
    <v-row align="center">
      <v-col cols="12" sm="12"
        id="primeSearch">
        <v-toolbar flat color="grey lighten-2" class="px-2">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn small fab text color="secondary" v-on="on" :loading="isLoading" @click="reset">
                <v-icon small>fal fa-redo</v-icon>
              </v-btn>
            </template>
            <span>リセットする</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn fab text small v-on="on" :disabled="isLoading" @click="search">
                <v-icon small>fal fa-search</v-icon>
              </v-btn>
            </template>
            <span>検索する</span>
          </v-tooltip>
          <v-text-field solo flat hide-details clearable
            v-model="form.primary"
            background-color="transparent"
            placeholder="かな or 名前"
            clear-icon="fal fa-times"
            @keypress.enter.prevent="search"
          ></v-text-field>
          <v-tooltip bottom right>
            <template v-slot:activator="{ on }">
              <v-btn fab text small
                v-on="on"
                @click="showDetails"><v-icon small>fa-caret-down</v-icon>
              </v-btn>
            </template>
            <span>詳細項目を表示する</span>
          </v-tooltip>
          <v-menu bottom
            v-model="config.status.search"
            :close-on-content-click="false"
            :nudge-bottom="70"
            :attach="'#primeSearch'">
            <v-card>
              <v-card-text>
                <v-row dense>
                  <v-col :col="isAdmin ? '3' : '6'">
                    <v-select v-model="form.author"
                      :items="getConsultantItems"
                      label="担当者"
                      @change="search"
                    />
                  </v-col>
                  <v-col :col="isAdmin ? '3' : '6'">
                    <v-select multiple
                      color="secondary"
                      v-model="form.type"
                      :items="getTypeItems"
                      label="カテゴリ"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-select multiple
                      v-if="isAdmin"
                      color="secondary"
                      v-model="form.status"
                      :items="getStatusItems"
                      item-text="text"
                      item-value="value"
                      label="ステータス"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field clearable
                      v-model="form.contact"
                      label="電話番号 or Eメール"
                      @keypress.enter.prevent="search"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field clearable
                      v-model="form.id"
                      label="ID"
                      @keypress.enter.prevent="search"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed
                  color="secondary"
                  @click="search">検索する</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row dense align="center" class="mt-2">
      <v-col cols="12" sm="3" md="2" class="fm-in">
        <p class="caption grey--text text--darken-2">表示数</p>
        <v-btn-toggle mandatory dense class="transparent" v-model="form.limit" @change="search">
          <v-btn :text="form.limit !== '20'" :depressed="form.limit === '20'" color="secondary white--text" value="20">20</v-btn>
          <v-btn :text="form.limit !== '50'" :depressed="form.limit === '50'" color="secondary white--text" value="50">50</v-btn>
          <v-btn :text="form.limit !== '100'" :depressed="form.limit === '100'" color="secondary white--text" value="100">100</v-btn>
        </v-btn-toggle>
      </v-col>
      <v-spacer></v-spacer>
      <v-col v-if="!isLoading" cols="4" sm="2" class="py-2">
        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on">{{ printPageInfo }}</v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="searchFirstPage">
              <v-list-item-title class="caption text-center">最初</v-list-item-title>
            </v-list-item>
            <v-list-item @click="searchLastPage">
              <v-list-item-title class="caption text-center">最後</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
      <v-spacer v-if="$vuetify.breakpoint.xsOnly"></v-spacer>
      <v-col cols="2" sm="1" md="1" lg="1" class="py-2">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon
              v-on="on"
              color="secondary"
              :disabled="isLoading || !isAccessiblePrev"
              @click="prev">
              <v-icon small>fal fa-chevron-left</v-icon>
            </v-btn>
          </template>
          <span>前へ</span>
        </v-tooltip>
      </v-col>
      <v-col cols="2" sm="1" md="1" lg="1" class="py-2">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon
              v-on="on"
              color="secondary"
              :disabled="isLoading || !isAccessibleNext"
              @click="next">
              <v-icon small>fal fa-chevron-right</v-icon>
            </v-btn>
          </template>
          <span>次へ</span>
        </v-tooltip>
      </v-col>
      <v-col cols="2" sm="1" md="1" lg="1" class="py-2">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon
              v-on="on"
              color="secondary"
              @click="open({ type: 'insert' })">
              <v-icon small>fal fa-plus</v-icon>
            </v-btn>
          </template>
          <span>新規に追加する</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <InsertModal ref="inserter" :type="'client'" @done="search" />
  </v-card>
</template>
<script>
import InsertModal from '@/components/modals/client'

const DEF = {
  FORM: {
    limit: '20',
    author: '',
    id: '',
    contact: '',
    status: [],
    type: [],
    page: 1,
    size: 99
  }
}
const ICONS = {
  ORDER: {
    DIR: {
      ASC: ['fal', 'sort-numeric-down'],
      DESC: ['fal', 'sort-numeric-up']
    }
  }
}

export default {
  name: 'authorClientsHeader',
  components: {
    InsertModal
  },
  props: [
    'status'
  ],
  data () {
    return {
      config: {
        status: {
          search: false
        },
        limit: {
          20: 20,
          50: 50,
          100: 100
        }
      },
      meta: {
        authors: [],
        order: {
          dir: {
            asc: ICONS.ORDER.DIR.ASC,
            desc: ICONS.ORDER.DIR.DESC
          }
        }
      },
      form: {
        id: DEF.FORM.id,
        primary: DEF.FORM.primary,
        author: DEF.FORM.author,
        contact: DEF.FORM.contact,
        status: DEF.FORM.status,
        type: DEF.FORM.type,
        limit: DEF.FORM.limit,
        page: DEF.FORM.page,
        size: DEF.FORM.size
      },
      store: {
        authors: {}
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
      this.search()
    },
    showDetails: function () {
      this.config.status.search = true
    },
    search: function (page) {
      if (this.$props.status && !this.$props.status.loading) {
        this.$emit('emit', {
          action: 'get',
          data: Object.assign(this.form, {
            page: (page != null && Number.isFinite(page)) ? page : 1
          })
        })
      }
    },
    searchFirstPage: function () {
      this.$set(this.form, 'page', 1)
      this.search(1)
    },
    searchLastPage: function () {
      const { limit, size } = this.form
      const last = Math.floor(size / limit) + ((size % limit) > 0 ? 1 : 0)
      this.$set(this.form, 'page', last)
      this.search(last)
    },
    prev: function () {
      let num = this.form.page
      if (num !== 1) {
        this.$set(this.form, 'page', num - 1)
        this.search(num - 1)
      }
    },
    next: function () {
      let num = this.form.page
      if (num !== this.form.size) {
        this.$set(this.form, 'page', num + 1)
        this.search(num + 1)
      }
    },
    count: function (size) {
      this.$set(this.form, 'size', size)
    },
    open: function (req) {
      const { type } = req || {}
      if (type === 'insert') {
        this.$refs.inserter.open()
      }
    },
    reset: function () {
      this.$set(this, 'form', JSON.parse(JSON.stringify(DEF.FORM)))
      this.search(1)
    },
    getForm: function () {
      return this.form
    },
    updatePage: function (page) {
      this.$set(this.form, 'page', page)
    }
  },
  computed: {
    isLoading () {
      return (this.$props.status && this.$props.status.loading)
    },
    isAccessibleNext () {
      return ((this.form.size - this.form.page * this.form.limit) > 0)
    },
    isAccessiblePrev () {
      return ((this.form.page - 1) > 0)
    },
    isAdmin () {
      let roles = this.$store.getters['author/get']('roles')
      return roles.includes('admin')
    },
    getConsultantItems () {
      const authors = this.$store.getters['config/get']('authors')
      const keys = Object.keys(authors)
      return [
        {
          value: '',
          text: '選択なし'
        },
        ...(keys.length ? keys.filter(key => {
          return authors[key].roles.includes('consultant')
        }).map(key => {
          return {
            text: authors[key].name[0] || key,
            value: key
          }
        }) : [])
      ]
    },
    getTypeItems () {
      return [
        { value: 'client', text: '顧客' },
        { value: 'guardian', text: '保護者' }
      ]
    },
    getStatusItems () {
      return [
        {
          value: 0,
          text: '非表示'
        },
        {
          value: 1,
          text: '表示'
        }
      ]
    },
    printPageInfo () {
      let limit = parseInt(this.form.limit)
      let num = this.form.page
      let st = limit * (num - 1) + 1
      let ed = Math.min(limit * num, this.form.size)
      return st + ' - ' + ed + ' / ' + this.form.size
    }
  }
}
</script>
<style lang="scss">
.auth-clients--header {
  .fm-in {
    position: relative;
    .caption {
      position: absolute;
      top: -1.2em;
    }
  }
}
</style>
